import Image from "next/image";
import styles from "../upsc-prefit-prelims-test-series/Prefit.module.css";
import Link from "next/link";
const Prefit = () => {
 
  return (
    <>


    {/* New table Format*/}
<div className="container d-none d-lg-block">
    <div className='py-2' style={{backgroundColor: "#001e62"}}>
        <h2 className={`${styles.tabletitle}`}>UPSC Prelims Test Series 2025 | Prefit Test</h2>
    </div>

    <div className={`${styles.tablescroll} prelimstable`}>
       <table class="table">
            <thead className={`${styles.table1}`} >
                 <tr>
                    <td className={`${styles.tableheading}`}>Center<br /></td>
                    <td className={`${styles.tableheading}`}>Batch<br /></td>
                    <td className={`${styles.tableheading}`}>Starts On<br /></td>  
                    <td className={`${styles.tableheading}`}>Schedule<br /></td>
                    <td className={`${styles.tableheading}`}>Brochure<br /></td>
                    <td className={`${styles.tableheading}`}>Payment<br /></td>
                 </tr>
            </thead>

            <tbody>

                <tr className="pt-2">
                     <td className={`${styles.tablepara} border-0`}>Trichy<br/></td>
                     <td className={`${styles.tablepara}`}>Batch III Regular (Offline / Online) </td>
                     <td className={`${styles.tablepara}`}>10th March 2025<br /></td>
                     <td><Link href="/pdf/Prefit-2025/PREFIT-B3-Schedule-2025.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                     <td><Link href="/pdf/Prefit-2025/trichy/Prefit-B3-Brochure-2025-Trichy.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                     <td className="border-0"><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                </tr> 


                 <tr className="pt-2">
                     <td className={`${styles.tablepara} border-0`}>Trichy<br /></td>
                     <td className={`${styles.tablepara}`}>Batch II Regular (Offline / Online) </td>
                     <td className={`${styles.tablepara}`}>17th Feb 2025<br /></td>
                     <td><Link href="/pdf/Prefit-2025/PREFIT-2025-2nd-BATCH-SCHEDULE.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                     <td><Link href="/pdf/Prefit-2025/trichy/Prefit-Batch-2-brochure-2025-Trichy.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                     <td className="border-0"><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                </tr>  

                 <tr className="pt-2">
                     <td className={`${styles.tablepara} border-0`}>Trichy<br /></td>
                     <td className={`${styles.tablepara}`}>Batch I Regular (Offline / Online) </td>
                     <td className={`${styles.tablepara}`}>28th Jan 2025<br /></td>
                     <td><Link href="/pdf/Prefit-2025/PREFIT-2025-SCHEDULE.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                     <td><Link href="/pdf/Prefit-2025/trichy/Prefit-brochure-B1-Trichy-2025.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                     <td className="border-0"><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                </tr>        
            </tbody>
        </table>
    </div> 
</div>

<div className="container d-lg-none">

<div className="row border-bottom pt-3 ">
        
        <div class="col-6 pt-3 d-block d-md-none"><b>Center</b></div>
        <div class="col-6 pt-3 col-md-3">Trichy</div>
        
        <div class="col-6 pt-3 d-block d-md-none"><b>Mode</b></div>
        <div class="col-6 pt-3 col-md-3">Batch III- (Offline / Online)</div>
        
        <div class="col-6 pt-3 d-block d-md-none"><b>Starts On</b></div>
        <div class="col-6 pt-3 col-md-3">10th March 2025</div>

        <div class="col-6 pt-3 d-block d-md-none"><b>Schedule</b></div>
        <div class="col-6 pt-3 col-md-3"><b><Link href="/pdf/Prefit-2025/PREFIT-B3-Schedule-2025.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></b></div>
        
        <div class="col-6 pt-3 d-block d-md-none"><b>Brochure</b></div>
        <div class="col-6 pt-3 col-md-3"><b><Link href="/pdf/Prefit-2025/trichy/Prefit-B3-Brochure-2025-Trichy.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></b></div>

        <div class="col-6 pt-3  d-block d-md-none"><b>Admission</b></div>
        <div class="col-6 pt-3 pb-3 col-md-3"><b><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></b></div>

  </div>

   <div className="row border-bottom pt-3 ">
        
        <div class="col-6 pt-3 d-block d-md-none"><b>Center</b></div>
        <div class="col-6 pt-3 col-md-3">Trichy</div>
        
        <div class="col-6 pt-3 d-block d-md-none"><b>Mode</b></div>
        <div class="col-6 pt-3 col-md-3">Batch II- (Offline / Online)</div>
        
        <div class="col-6 pt-3 d-block d-md-none"><b>Starts On</b></div>
        <div class="col-6 pt-3 col-md-3">17th Feb 2025</div>

        <div class="col-6 pt-3 d-block d-md-none"><b>Schedule</b></div>
        <div class="col-6 pt-3 col-md-3"><b><Link href="/pdf/Prefit-2025/PREFIT-2025-2nd-BATCH-SCHEDULE.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></b></div>
        
        <div class="col-6 pt-3 d-block d-md-none"><b>Brochure</b></div>
        <div class="col-6 pt-3 col-md-3"><b><Link href="/pdf/Prefit-2025/trichy/Prefit-Batch-2-brochure-2025-Trichy.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></b></div>

        <div class="col-6 pt-3  d-block d-md-none"><b>Admission</b></div>
        <div class="col-6 pt-3 pb-3 col-md-3"><b><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></b></div>

  </div>


<div className="row border-bottom pt-3 ">
        
        <div class="col-6 pt-3 d-block d-md-none"><b>Center</b></div>
        <div class="col-6 pt-3 col-md-3">Trichy</div>
        
        <div class="col-6 pt-3 d-block d-md-none"><b>Mode</b></div>
        <div class="col-6 pt-3 col-md-3">Batch I- (Offline / Online)</div>
        
        <div class="col-6 pt-3 d-block d-md-none"><b>Starts On</b></div>
        <div class="col-6 pt-3 col-md-3">28th Jan 2025</div>

        <div class="col-6 pt-3 d-block d-md-none"><b>Schedule</b></div>
        <div class="col-6 pt-3 col-md-3"><b><Link href="/pdf/Prefit-2025/PREFIT-2025-SCHEDULE.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></b></div>
        
        <div class="col-6 pt-3 d-block d-md-none"><b>Brochure</b></div>
        <div class="col-6 pt-3 col-md-3"><b><Link href="/pdf/Prefit-2025/trichy/Prefit-brochure-B1-Trichy-2025.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></b></div>

        <div class="col-6 pt-3  d-block d-md-none"><b>Admission</b></div>
        <div class="col-6 pt-3 pb-3 col-md-3"><b><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></b></div>

  </div>
</div>


<div className="container mb-3">
   <div className="row">
   <div className="col-md-6 col-xl-4 mb-3 mb-md-4 col-12 pt-4">
       <div className={`${styles.facultyborder3} p-4 h-100`}>
       <div className='' style={{backgroundColor: "#001e62"}}>
         <p className={`${styles.tabletitle}`}>Exam Pattern </p>
        </div>

      <div className={`${styles.tablescroll} prelimstable`}>
       <table class="table">
            <thead className={`${styles.table1}`} >
                 <tr>
                    <td className={`${styles.tableheading}`}>Half Test<br /></td>
                    <td className={`${styles.tableheading}`}>Full Test<br /></td>
                 </tr>
            </thead>
            <tbody>
                 <tr className="pt-2">
                     <td className={`${styles.tablepara} border-0`}>50 Qns (1 hr)<br /></td>
                     <td className={`${styles.tablepara}`}>100 Qns (2 hr) </td>
                                     </tr> 
            </tbody>
        </table>
      </div>
     
       </div>
   </div>

     <div className="col-md-6 col-xl-4 mb-3 mb-md-4 col-12 pt-4">
       <div className={`${styles.facultyborder3} p-4 h-100`}>
         <p className={`${styles.sectionsubtitle}`}>Fee</p>
         <div className="row">
           <div className="col-lg-4 col-5 col-md-6">
             <p className={`${styles.sectionredtitle} mb-0`}><b>₹</b>5000/-</p>
           </div>
           <div className="col-lg-8 col-7 col-md-6">
             <p className={`${styles.acheiverrank} px-xl-4 mb-0`}>New Students</p>
           </div>
         </div>
         <div className="row pt-3">
           <div className="col-lg-4 col-5 col-md-6">
             <p className={`${styles.sectionredtitle}`}><b>₹</b>4,500/-</p>
           </div>
           <div className="col-lg-8 col-7 col-md-6">
             <p className={`${styles.acheiverrank} px-xl-4`}>Old Students</p>
           </div>
         </div>
       </div>
     </div>

     <div className="col-md-6 col-xl-4 mb-3 mb-md-4 col-12 pt-5">
      
       <p className="pt-lg-0 pt-xl-3"><Link href="/upsc-prestorming-prelims-test-series"><button className={`${styles.normalbutton2}`} type="submit">Click here for Prestorming</button></Link></p>
      
     </div>

  </div>
</div>



{/*  <div className="container mb-4">
         <div className="row">
          <div className="col">
                <h2 className={`${styles.sectiontitle} pt-3 mb-0`}>Prefit Test Series 2025</h2>
            </div>
        </div>

        <div className="row">
            <div className="col-lg-6 col-12">
            <p className={`${styles.acheivername}`}>Anna Nagar Schedule</p>
                   <p className={`${styles.acheiverrank1} mb-0`}><Link href="/pdf/prefit-2025/annanagar/Prefit-brochure-2024-Anna-nagar-1.pdf" rel="noreferrer" target="_blank" className={`${styles.program}`}>Prefit 2025 Batch I (Jan 28th) Brochure</Link></p>
                  
                   
            </div>
            
            <div className="col-lg-6 col-12">
            <p className={`${styles.acheivername}`}>Adyar Schedule</p>
                   <p className={`${styles.acheiverrank1} mb-0`}><Link href="/pdf/prefit-2025/adyar/Prefit-brochure-2024-Adyar-1.pdf" rel="noreferrer" target="_blank" className={`${styles.program}`}>Prefit 2025 Batch I (Jan 28th)  Brochure</Link></p>
                   
                   
            </div> 

            <div className="row pt-5">
            <div className="col-lg-6 col-12">
                <p className={`${styles.acheivername}`}>Exam Pattern & Fee Structure</p>
                <p className={`${styles.acheiverrank1} mb-0`}>Half Test: 50 Questions (1 hour) </p>
                <p className={`${styles.acheiverrank1} mb-0`}>Full Test: 100 Questions (2 hours) </p>
                <p className={`${styles.acheiverrank1} mb-0`} style={{color:"#DB1B0D"}}>* Mode Of Exam : Both offline & online</p>
                <div className="row pt-2" >
                    <div className=" col-xl-7 col-lg-10 col-md-6 mb-3 mb-md-4 col-12">
                        <div className={`${styles.facultyborder3} p-4 h-100`}>
                            <div className="row">
                            <div className="col-lg-4 col-5 col-md-6">
                                <p className={`${styles.sectionredtitle} mb-0`}><b>₹</b>5,000/-</p>
                            </div>
                            <div className="col-lg-8 col-7 col-md-6">
                                <p className={`${styles.acheiverrank} px-xl-4 mb-0`}>New Students</p>
                            </div>
                            </div>
                            <div className="row pt-3">
                            <div className="col-lg-4 col-5 col-md-6">
                                <p className={`${styles.sectionredtitle}`}><b>₹</b>4,500/-</p>
                            </div>
                            <div className="col-lg-8 col-7 col-md-6">
                                <p className={`${styles.acheiverrank} px-xl-4`}>Old Students</p>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-xl-4 col-12 mb-lg-0">
                    <p className="pt-3"><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank"><button className={`${styles.normalbutton3}`} type="submit">Pay Now</button></Link></p>
                    </div>
                    <div className="col-xl-8 col-12">
                    <p className="pt-lg-0 pt-xl-3"><Link href="/upsc-prestorming"><button className={`${styles.normalbutton2}`} type="submit">Click here for Prestorming</button></Link></p>
                    </div>
                    <p className={`${styles.aboutparagraph1} p-2`}><span className={`${styles.dot}`}>*</span>&nbsp; &nbsp; <span>Old student discount will be applicable only at spot payment.</span></p>
                </div>

            </div>
            </div>
  
        </div>
    </div>*/}




</>
);
};

export default Prefit;